import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BeginYourJourneyToBetterSleep() {
  return <section data-section-id="237246" id="ready-to-transform" className="dark relative overflow-hidden bg-[#15191D] py-16 sm:py-24 lg:py-[110px]">
      {/* Background image */}
      <img src="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/roof-cleaned-and-done.jpg?v=zjq9t5ekt5e" alt="Tiled residential roof restored and cleaned in Southampton" className="absolute inset-0 h-full w-full object-cover" data-wvc-srcset="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/roof-cleaned-and-done.jpg?v=zjq9t5ekt5e-wvc-srcset" data-wvc-sizes="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/roof-cleaned-and-done.jpg?v=zjq9t5ekt5e-wvc-sizes" />

      {/* Charcoal overlay at 80-85% opacity */}
      <div className="absolute inset-0 bg-[#15191D]/85" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-4xl">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tight mb-6 text-white">
          Ready for Expert Roofing Services in Southampton?
        </h2>

        <p className="text-base sm:text-lg md:text-xl text-white/80 font-default mb-10 max-w-2xl leading-relaxed">
          From emergency roofing repairs and new roofs to flat roofing, chimneys and fascias, Matt and the team at Firststop Roofing Ltd
          deliver architectural precision and lasting durability across Southampton, Hampshire &amp; surrounding areas.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center items-center">
          <a href="tel:07443802652" className="w-full sm:w-auto">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base sm:text-lg rounded-md bg-primary text-primary-foreground font-semibold shadow-md transition-all hover:bg-primary-hover">
              Call Matt: 07443 802652
            </Button>
          </a>
          <Link to="/GetInTouchPage" className="w-full sm:w-auto">
            <Button variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base sm:text-lg rounded-md bg-transparent border-2 border-white text-white font-semibold transition-all hover:bg-white hover:text-[#15191D]">
              Get an Online Quote
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}